import '../styles/app.scss';
import './_images';
import HeroSlider from './components/hero-slider';
import ScrollSlider from './components/scroll-slider';
import Marquee from './components/marquee';
import HeaderLanguage from './components/header-language';
import OfficeTabs from './components/office-tabs';
import EntranceAnimation from './components/entrance-animation';

EntranceAnimation.markReady();

document.addEventListener(
	'DOMContentLoaded',
	() => {
		HeroSlider.init();
		ScrollSlider.init();
		Marquee.init();
		HeaderLanguage.init();
		OfficeTabs.init();
		EntranceAnimation.init();
	},
	false
);
